import en from './translations/en.json';
import id from './translations/id.json';
import pt from './translations/pt.json';
import es from './translations/es.json';
import vi from './translations/vi.json';
import zh from './translations/zh.json';
import fr from './translations/fr.json';
import sw from './translations/sw.json';

export const DICTIONARIES = { en, id, pt, es, vi, zh, fr, sw };

export const SUPPORTED_LANGS = [
  { code: 'en', label: 'English' },
  { code: 'id', label: 'Bahasa Indonesia' },
  { code: 'pt', label: 'Português' },
  { code: 'es', label: 'Español' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'zh', label: '中文' },
  { code: 'fr', label: 'Français' },
  { code: 'sw', label: 'Kiswahili' }
];
